var map = {
	"./blackGold/footer/user.png": 70463,
	"./brownGold/footer/user.png": 56282,
	"./darkBlue/footer/user.png": 44391,
	"./greenYellow/footer/user.png": 81187,
	"./redGold/footer/user.png": 7404,
	"./skyBlue/footer/user.png": 20936,
	"./whiteGold/footer/user.png": 84486,
	"./yellowWhite/footer/user.png": 18394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87054;